module.exports = __webpack_public_path__ + "img/img9.0ed45485.png";